import { DataAccess, ResponseMessage } from "../../../dataaccess/data.access";
import { Proto } from "../../../pojo/Proto";
import ISODateString = Proto.ISODateString;

export interface ApprovalGroup {
    approvalGroupId?: number;
    name: string;
    createDate?: ISODateString;
    lastModDate?: ISODateString;
    lastModUser?: string;
    contacts?: ApprovalGroupContact[];
}

export interface ApprovalGroupContact {
    approvalGroupId?: number;
    contId: number;
    contactName?: string;
}

export interface ApprovalGroupContactChanges {
    contactsToAdd: ApprovalGroupContact[];
    contactsToRemove: ApprovalGroupContact[];
}

export class ApprovalGroupService {
    /**
     * Get all approval groups
     */
    public static async getApprovalGroups(): Promise<ApprovalGroup[]> {
        const groups = (await DataAccess.get<ApprovalGroup[]>("/approval-group/all.json")) ?? [];
        return groups;
    }

    /**
     * Get approval group by ID
     */
    public static async getApprovalGroup(approvalGroupId: number): Promise<ApprovalGroup> {
        return await DataAccess.get<ApprovalGroup>(`/approval-group/${approvalGroupId}.json`);
    }

    /**
     * Create a new approval group
     */
    public static createApprovalGroup(approvalGroup: ApprovalGroup): Promise<ResponseMessage> {
        return DataAccess.post<ResponseMessage>("/approval-group/new.json", approvalGroup);
    }

    /**
     * Update an existing approval group
     */
    public static updateApprovalGroup(approvalGroupId: number, approvalGroup: ApprovalGroup): Promise<ResponseMessage> {
        return DataAccess.put<ResponseMessage>(`/approval-group/${approvalGroupId}.json`, approvalGroup);
    }

    /**
     * Delete an approval group
     */
    public static deleteApprovalGroup(approvalGroupId: number): Promise<ResponseMessage> {
        return DataAccess.delete<ResponseMessage>(`/approval-group/${approvalGroupId}.json`);
    }

    /**
     * Update approval group contacts with differential changes
     */
    public static updateApprovalGroupContacts(
        approvalGroupId: number,
        contactChanges: ApprovalGroupContactChanges,
    ): Promise<ResponseMessage> {
        return DataAccess.put<ResponseMessage>(`/approval-group/${approvalGroupId}/contacts.json`, {
            ApprovalGroupContactChanges: contactChanges,
        });
    }
}
